import { invoke } from '../../QTBridge';

export const readyToload = () => {
  invoke('webLoadSuccessed').catch((e) => console.error(e));
};
